import type {ReactNode} from 'react'
import {StickyFooter} from '@freckle/school/ts/common/components/sticky-footer'
import {
  bothChildrenWrapper,
  leftChildStyle,
  rightChildOnlyWrapper,
  stickyBar
} from './import-roster-footer.module.scss'

type Props = {
  leftChildren?: ReactNode
  rightChildren: ReactNode
}

export default function ImportRosterFooter(props: Props) {
  const {leftChildren, rightChildren} = props

  const body =
    leftChildren !== null && leftChildren !== undefined ? (
      <div className={bothChildrenWrapper}>
        <div className={leftChildStyle}>{leftChildren}</div>
        <div>{rightChildren}</div>
      </div>
    ) : (
      <div className={rightChildOnlyWrapper}>
        <div>{rightChildren}</div>
      </div>
    )

  return <StickyFooter className={stickyBar}>{body}</StickyFooter>
}
